// The public pricing ladder (ADR-0029), typed for the pages that render it.
//
// pricingPlans.json is a byte-for-byte copy of
// backend/src/config/pricingPlans.json, which is the source; a backend test
// fails if the two differ. Edit the backend file, then copy it here. Every
// page that shows a plan, a price or the founding-partner offer reads it from
// this module, so there is one ladder on the site.
import pricingPlans from './pricingPlans.json'

export type PublicPlanId = 'professional' | 'growth' | 'consultant'

export interface PricingPlan {
  id: PublicPlanId
  name: string
  priceMonthly: number
  maxClients: number
  stripePriceEnv: string
  audience: string
  features: string[]
}

export const PRICING_PLANS = pricingPlans.plans as PricingPlan[]
export const FOUNDING_PARTNER = pricingPlans.foundingPartner
export const INCLUDED_IN_EVERY_PLAN: string[] = pricingPlans.includedInEveryPlan
export const CLIENT_LIMIT_NOTE: string = pricingPlans.clientLimitNote
export const NOT_BUILT_YET: string = pricingPlans.notBuiltYet

/** "$1,999" */
export function formatPrice(amount: number): string {
  return `$${amount.toLocaleString('en-US')}`
}

const cheapest = PRICING_PLANS.reduce((min, plan) => (plan.priceMonthly < min.priceMonthly ? plan : min))

/** "$399/mo": the lowest list price, for "plans from ..." lines. */
export const LOWEST_PRICE_LABEL = `${formatPrice(cheapest.priceMonthly)}/mo`

/** Display name for an internal tier id ("consultant" -> "Firm"). */
export function planDisplayName(tierId: string | undefined | null): string {
  const plan = PRICING_PLANS.find((p) => p.id === tierId)
  if (plan) return plan.name
  switch (tierId) {
    case 'quick':
      return 'Starter (legacy)'
    case 'enterprise':
      return 'Enterprise'
    case 'free':
      return 'Free (legacy)'
    default:
      return tierId ?? ''
  }
}
